import { TripOption } from "../../CommonLandingMweb.types";
import {
  Container,
  Content,
  InfoIcon,
  Option,
  Radio,
  Row,
  SubTitle,
  TagImage,
  Title,
} from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

interface TripOptionsProps {
  tripOptions?: TripOption[];
  selectedOptionId?: string | null;
  onOptionSelect?: (option: TripOption) => void;
  onInfoPress?: (option: TripOption) => void;
}

export const TripOptions = ({
  tripOptions = [],
  selectedOptionId,
  onOptionSelect,
  onInfoPress,
}: TripOptionsProps) => {
  if (!tripOptions.length) return null;

  return (
    <Container>
      {tripOptions.map((option) => {
        const selected = selectedOptionId === option.id;
        return (
          <Option key={option.id} onClick={() => onOptionSelect?.(option)}>
            <Radio $selected={selected} />
            <Content>
              <Row>
                <Title>
                  <FormattedText value={option.name || option.id} />
                </Title>
                {option.icon ? (
                  <InfoIcon
                    src={option.icon}
                    alt="info"
                    onClick={(event) => {
                      event.stopPropagation();
                      onInfoPress?.(option);
                    }}
                  />
                ) : null}
                {option.tagImg ? <TagImage src={option.tagImg} alt="tag" /> : null}
              </Row>
              <SubTitle $accent={selected}>
                <FormattedText value={option.subTitle} />
              </SubTitle>
            </Content>
          </Option>
        );
      })}
    </Container>
  );
};

